import {
  EcgServiceValues,
  EcgServiceHeartRateValues,
  EcgServiceWaveFormValues,
  EcgServiceBatteryValues
} from './ble'

declare const dateNominality: unique symbol

export type DateString = string & { [dateNominality]: never }

export const isDateString = (value: string): value is DateString => {
  return /^\d{4}-\d{2}-\d{2}$/.test(value)
}

declare const datetimeNominality: unique symbol

export type DatetimeString = string & { [datetimeNominality]: never }

export const isDatetimeString = (value: string): value is DateString => {
  return /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value)
}

export type PartiallyRequired<T, K extends keyof T> = Omit<T, K> &
  Required<Pick<T, K>>

export const isEcgServiceHeartRateValues = (
  values: EcgServiceValues
): values is EcgServiceHeartRateValues => {
  return Boolean((values as EcgServiceHeartRateValues).heartRate)
}

export const isEcgServiceWaveFormValues = (
  values: EcgServiceValues
): values is EcgServiceWaveFormValues => {
  return Boolean((values as EcgServiceWaveFormValues).ecg)
}

export const isEcgServiceBatteryValues = (
  values: EcgServiceValues
): values is EcgServiceBatteryValues => {
  return Boolean((values as EcgServiceBatteryValues).battery)
}
